export default __webpack_public_path__ + "static/media/Coursera.6980460b.png";